<template>
  <BaseSection is-wide>
    <template #content>
      <BaseText
        size="m"
        data-animation="fadeInRight"
        data-animation-delay="100"
        v-html="'Наступивший коронакризис скорректировал условия труда и&nbsp;расставил акценты. На передний план вышли ценности:'"
      />
      <div class="section__gap">
        <BaseSteps :items="valuation" :delay="300" is-triple />
      </div>
      <hr
        class="app__sep"
        data-animation="fadeIn"
        data-animation-delay="600"
      />
      <BaseText
        size="m"
        data-animation="fadeInRight"
        data-animation-delay="900"
        v-html="'Обеспечить данные ценности не просто, потому что между ними и&nbsp;их&nbsp;реализацией существует ряд проблем:'"
      />
      <div class="section__gap section__gap_double">
        <BaseFeatures :items="features" :delay="1200" is-triple />
      </div>
    </template>
  </BaseSection>
</template>

<script>
import pageMixin from '@/mixins/page';
import BaseSection from '@/components/BaseSection.vue';
import BaseText from '@/components/BaseText.vue';
import BaseSteps from '@/components/BaseSteps.vue';
import BaseFeatures from '@/components/BaseFeatures.vue';

export default {
  name: 'ValuationPage',
  mixins: [pageMixin],
  components: {
    BaseSection,
    BaseText,
    BaseSteps,
    BaseFeatures,
  },
  staticData: () => ({
    valuation: [
      {
        text: 'Человеческое общение',
        attrs: { size: 's' },
      },
      {
        text: 'Баланс между работой и&nbsp;личной жизнью',
        attrs: { size: 's' },
      },
      {
        text: 'Нерутинный труд и&nbsp;возможность развиваться',
        attrs: { size: 's' },
      },
    ],
    features: [
      {
        image: 'communication',
        title: 'Человеческое общение',
        list: [
          { text: 'Невозможность личной встречи' },
          { text: 'Выход в&nbsp;оффлайн части рабочих функций' },
          { text: 'Минимизация неформального оффлайн общения' },
          { text: 'Возможность нарушения коммуникации и&nbsp;неправильной интерпретации среди коллег' },
          { text: 'Ухудшение командного климата' },
        ],
      },
      {
        image: 'balance',
        title: 'Баланс между работой и&nbsp;личной&nbsp;жизнью',
        list: [
          { text: 'Нефиксированные часы начала и&nbsp;окончания рабочего дня ' },
          { text: 'Слияние личного и&nbsp;профессионального пространства' },
          { text: 'Затруднение в&nbsp;распределении рабочей нагрузки' },
        ],
      },
      {
        image: 'develop',
        title: 'Нерутинный труд и&nbsp;возможность развиваться',
        list: [
          { text: 'Нефиксированные часы начала и&nbsp;окончания рабочего дня' },
          { text: 'Слияние рабочего и&nbsp;профессионального пространства' },
          { text: 'Затруднение в&nbsp;распределении рабочей нагрузки' },
        ],
      },
    ],
  }),
};
</script>
